import { requestViaSms } from "../../visitWidgetApi";
import { AppDispatch } from "@store/store";
import { logError } from "@lib/logger";
import { setAuthViewAction, setSMSTokenAction } from "@store/sessionReducer";

export interface SendSmsLoginOtpActionParams {
  phone: string;
}

/*
 * Send SMS login OTP
 */
const sendSmsLoginOtpAction =
  ({ phone }: SendSmsLoginOtpActionParams) =>
  async (dispatch: AppDispatch) => {
    try {
      const response = await requestViaSms(phone);
      dispatch(
        setSMSTokenAction({
          smsAuthToken: {
            phone: phone,
            temporarySmsToken: response.temporarySmsToken,
          },
        }),
      );
      dispatch(setAuthViewAction({ authView: "smsVerify" }));
    } catch (error) {
      logError(error);
      throw error;
    }
  };

export { sendSmsLoginOtpAction };
